import { Autocomplete, CircularProgress, TextField } from "@mui/material"
import { useGetProductsQuery } from "@store/services/productsService"
import { useImmerAtom } from "jotai-immer"
import { memo } from "react"
import { AutocompleteOnChange, OrgToDivToProds } from "@components/NodeLink/types"
import { linkAtom } from "@components/NodeLink/linkAtom"

const OrgAutocomplete = memo((props: { orgToDivToProds: OrgToDivToProds }) => {
  const [link, updateLink] = useImmerAtom(linkAtom)
  const { isFetching } = useGetProductsQuery({ roleHint: "whatif" })

  const handleChange: AutocompleteOnChange = (_event, newValue) => {
    updateLink((draft) => {
      draft.org = newValue ?? ""
      draft.div = ""
      draft.prod = ""
      draft.family = ""
      draft.version = ""
      draft.node = ""
    })
  }

  const sortedOptions = [...props.orgToDivToProds.keys()].toSorted((orgA, orgB) =>
    orgA.localeCompare(orgB),
  )

  return (
    <Autocomplete
      options={sortedOptions}
      value={link.org || null}
      onChange={handleChange}
      renderInput={(params) => <TextField {...params} label="Organization" />}
      isOptionEqualToValue={(option, value) => option === value}
      loading={isFetching}
      loadingText={<CircularProgress size={20} />}
    />
  )
})
OrgAutocomplete.displayName = "OrgAutocomplete"

export default OrgAutocomplete
